import { Suspense } from "react";
import { RouterProvider } from "react-router-dom";

import ErrorBoundary from "@/components/common/ErrorBoundary";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import { Toaster } from "@/components/ui/sonner";

import router from "./routes/router";

function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingSpinner />}>
        <RouterProvider router={router} />
      </Suspense>
      <Toaster />
    </ErrorBoundary>
  );
}

export default App;
